import './scss/main.scss';

import { createApp } from 'vue';
import App from './App.vue';
import i18n from './i18n';
import { createVuestic } from 'vuestic-ui';
import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { sessionStorage } from 'aws-amplify/utils';

import stores from './stores';
import router from './router';
import vuesticGlobalConfig from './services/vuestic-ui/global-config';
import VueLuxon from 'vue-lux';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL,
      userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
      identityPoolId: import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID,
      loginWith: {
        email: true,
      },
      signUpVerificationMethod: 'code',
      userAttributes: {
        email: {
          required: true,
        },
      },
      allowGuestAccess: true,
      passwordFormat: {
        minLength: 12,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },
    },
  },
});

cognitoUserPoolsTokenProvider.setKeyValueStorage(sessionStorage);

const app = createApp(App);

app.use(stores);
app.use(router);
app.use(i18n);
app.use(VueLuxon, {
  input: {
    zone: 'Asia/Singapore',
    format: 'yyyy-MM-dd HH:mm:ss.SSS', // 2025-01-24 09:50:04.996
  },
  templates: {
    son: {
      zone: 'Asia/Singapore',
      format: 'yyyy-MM-dd HH:mm:ss.SSS', // 2025-01-24 09:50:04.996
    },
    shortSon: {
      zone: 'Asia/Singapore',
      format: 'yyyy-MM-dd HH:mm:ss', // 2025-01-24 09:50:04
    },
    videotimestamp: {
      format: 'seconds',
      zone: 'Asia/Singapore',
    },
    videostart: {
      format: 'MMM dd - HH:mm',
      zone: 'Asia/Singapore',
    },
    videoend: {
      format: 'HH:mm',
      zone: 'Asia/Singapore',
    },
  },
});
app.use(createVuestic({ config: vuesticGlobalConfig }));

app.mount('#app');
